const kNoFormatter = (no: number) => {
    const abs = Math.abs(Number(no));
    const sgn = Math.sign(Number(no));
    return abs > 999 ? `${sgn * +(abs / 1000).toFixed(1)}k` : sgn * abs;
};

export default kNoFormatter;
